const E = {
  view: 'view',
  edit: 'edit',
  copy: 'copy',
  share: 'share',
  'new template': 'new template',
  'new job': 'new job',
  'order supplies': 'order supplies',
  'export to excel': 'export to excel',
  download: 'download',
  'pay invoice': 'pay invoice',
  cancel: 'cancel',
  delete: 'delete',
  'add test': "add test",
  MultiDelete: 'Multi Delete',
  request: 'Request',
  paynow: 'Pay Now',
  receipt:'Receipt',
};

const F = {
  view: 'afficher',
  edit: 'modifier',
  copy: 'copier',
  share: 'partager',
  'new template': 'nouveau modèle',
  'new job': 'nouveau dossier',
  'order supplies': 'commander du matériel',
  'export to excel': 'exporter vers Excel',
  download: 'télécharger',
  'pay invoice': 'payer',
  cancel: 'annuler',
  delete: 'supprimer',
  'add test': "Ajouter une analyse",
  MultiDelete: 'Supprimer multiple',
  request: 'Demande',
  paynow: 'Payez maintenant',
  receipt: 'Reçu',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/menuOptions.js